/*
 * CO-4795 CDX-Suche – Frontend für die selbst gehostete Search & Discovery App (slk-search).
 *  - <predictive-search>: Instant-Suche im Header (übernimmt das Element, bevor theme.js es registriert)
 *  - <cdx-search-results>: Ergebnisseite mit Facetten, Sortierung, "verstanden"-Chips, Produktfamilien
 *  Fallback: Ist die App nicht erreichbar, läuft die gewohnte Shopify-Suche weiter.
 */
const CFG = window.cdxSearch;
const LANG = (CFG?.locale || document.documentElement.lang || 'de').slice(0, 2);

const STRINGS = {
  de: {
    ui: { clearAll: 'Zurücksetzen', sortBy: 'Sortieren nach', availability: 'Nur verfügbare Artikel', filterAndSort: 'Filtern und sortieren', filters: 'Filter', apply: 'Anwenden', count: (n) => (n === 1 ? '1 Produkt' : `${n} Produkte`), noFilterResults: 'Keine Produkte, die diesen Filterkriterien entsprechen.', clearFilter: 'Filter entfernen', offers: 'Angebote', onSale: 'Reduziert' },
    sortNames: { relevance: 'Am relevantesten', bestseller: 'meistverkauft', title_asc: 'Alphabetisch, A-Z', price_asc: 'Preis, niedrig nach hoch', price_desc: 'Preis, hoch nach niedrig', newest: 'Datum, neu zu alt', discount: 'Grösster Rabatt' },
    facetNames: { price: 'Preis', vendor: 'Marke', sizes: 'Grösse', alterVon: 'Alter (von)', alterBis: 'Alter (bis)', colors: 'Farben', age: 'Alter', categories: 'Kategorie', labels: 'Labels' },
    products: 'Produkte', collections: 'Kategorien', suggestions: 'Suchvorschläge', pages: 'Ratgeber & Seiten', popular: 'Beliebte Suchen', recent: 'Zuletzt gesucht', clear: 'Löschen', newIn: 'Neu bei uns',
    viewAll: 'Alle Ergebnisse für', noResults: 'Keine Treffer für', noResultsHint: 'Versuche eine andere Schreibweise oder einen allgemeineren Begriff.',
    understood: 'Verstanden', sale: 'Sale', soldOut: 'Ausverkauft', colors: (n) => `${n} Farben`, new: 'Neu',
    results: (n, q) => `${n} ${n === 1 ? 'Produkt' : 'Produkte'}${q ? ` für „${q}“` : ''}`, title: 'Suchergebnisse',
    filter: 'Filter', sort: 'Sortieren', resetAll: 'Alle Filter zurücksetzen', showResults: (n) => `${n} Produkte anzeigen`, more: 'Mehr laden', of: (a, b) => `${a} von ${b} Produkten`,
    sorts: { relevance: 'Relevanz', price_asc: 'Preis aufsteigend', price_desc: 'Preis absteigend', newest: 'Neuheiten', discount: 'Grösster Rabatt' },
    facets: { available: 'Verfügbarkeit', onlyAvailable: 'Nur verfügbare Produkte', onSale: 'Nur reduzierte Produkte', price: 'Preis', age: 'Alter', vendor: 'Marke', categories: 'Kategorie', colors: 'Farbe', labels: 'Labels' },
    showAll: 'Alle anzeigen', showLess: 'Weniger anzeigen', searchBrand: 'Marke suchen …', from: 'von', to: 'bis', apply: 'OK',
    semanticInfo: (q) => `Keine exakten Treffer für „${q}“ – diese Produkte passen inhaltlich am besten.`,
    relaxedInfo: 'Für alle Kriterien gab es nur wenige Treffer – wir zeigen dir zusätzlich ähnliche Produkte.',
    zeroTitle: (q) => `Leider nichts gefunden für „${q}“`, zeroHint: 'Vielleicht hilft dir einer dieser Begriffe weiter:', related: 'Passende Kategorien', removeChip: 'entfernen',
  },
  fr: {
    ui: { clearAll: 'Réinitialiser', sortBy: 'Trier par', availability: 'Uniquement disponibles', filterAndSort: 'Filtrer et trier', filters: 'Filtres', apply: 'Appliquer', count: (n) => (n === 1 ? '1 produit' : `${n} produits`), noFilterResults: 'Aucun produit ne correspond à ces critères', clearFilter: 'Retirer le filtre', offers: 'Promotions', onSale: 'En promotion' },
    sortNames: { relevance: 'Pertinence', bestseller: 'Meilleures ventes', title_asc: 'Alphabétique, A-Z', price_asc: 'Prix croissant', price_desc: 'Prix décroissant', newest: 'Date, plus récent', discount: 'Plus grande remise' },
    facetNames: { price: 'Prix', vendor: 'Marque', sizes: 'Taille', alterVon: 'Âge (de)', alterBis: 'Âge (à)', colors: 'Couleurs', age: 'Âge', categories: 'Catégorie', labels: 'Labels' },
    products: 'Produits', collections: 'Catégories', suggestions: 'Suggestions', pages: 'Conseils & pages', popular: 'Recherches populaires', recent: 'Recherches récentes', clear: 'Effacer', newIn: 'Nouveautés',
    viewAll: 'Tous les résultats pour', noResults: 'Aucun résultat pour', noResultsHint: 'Essayez une autre orthographe ou un terme plus général.',
    understood: 'Compris', sale: 'Promo', soldOut: 'Épuisé', colors: (n) => `${n} couleurs`, new: 'Nouveau',
    results: (n, q) => `${n} produit${n === 1 ? '' : 's'}${q ? ` pour « ${q} »` : ''}`, title: 'Résultats de recherche',
    filter: 'Filtres', sort: 'Trier', resetAll: 'Réinitialiser les filtres', showResults: (n) => `Afficher ${n} produits`, more: 'Charger plus', of: (a, b) => `${a} sur ${b} produits`,
    sorts: { relevance: 'Pertinence', price_asc: 'Prix croissant', price_desc: 'Prix décroissant', newest: 'Nouveautés', discount: 'Plus grande remise' },
    facets: { available: 'Disponibilité', onlyAvailable: 'Disponibles uniquement', onSale: 'En promotion uniquement', price: 'Prix', age: 'Âge', vendor: 'Marque', categories: 'Catégorie', colors: 'Couleur', labels: 'Labels' },
    showAll: 'Tout afficher', showLess: 'Afficher moins', searchBrand: 'Chercher une marque …', from: 'de', to: 'à', apply: 'OK',
    semanticInfo: (q) => `Aucun résultat exact pour « ${q} » – voici les produits les plus proches.`,
    relaxedInfo: 'Peu de résultats pour tous les critères – nous affichons aussi des produits similaires.',
    zeroTitle: (q) => `Aucun résultat pour « ${q} »`, zeroHint: 'Essayez peut-être :', related: 'Catégories associées', removeChip: 'retirer',
  },
  en: {
    ui: { clearAll: 'Reset', sortBy: 'Sort by', availability: 'Available items only', filterAndSort: 'Filter and sort', filters: 'Filters', apply: 'Apply', count: (n) => (n === 1 ? '1 product' : `${n} products`), noFilterResults: 'No products match those filters.', clearFilter: 'Remove filter', offers: 'Offers', onSale: 'On sale' },
    sortNames: { relevance: 'Most relevant', bestseller: 'Best selling', title_asc: 'Alphabetically, A-Z', price_asc: 'Price, low to high', price_desc: 'Price, high to low', newest: 'Date, new to old', discount: 'Biggest discount' },
    facetNames: { price: 'Price', vendor: 'Brand', sizes: 'Size', alterVon: 'Age (from)', alterBis: 'Age (to)', colors: 'Colours', age: 'Age', categories: 'Category', labels: 'Labels' },
    products: 'Products', collections: 'Categories', suggestions: 'Suggestions', pages: 'Guides & pages', popular: 'Popular searches', recent: 'Recent searches', clear: 'Clear', newIn: 'New in',
    viewAll: 'View all results for', noResults: 'No results for', noResultsHint: 'Try a different spelling or a more general term.',
    understood: 'Understood', sale: 'Sale', soldOut: 'Sold out', colors: (n) => `${n} colours`, new: 'New',
    results: (n, q) => `${n} product${n === 1 ? '' : 's'}${q ? ` for “${q}”` : ''}`, title: 'Search results',
    filter: 'Filter', sort: 'Sort', resetAll: 'Clear all filters', showResults: (n) => `Show ${n} products`, more: 'Load more', of: (a, b) => `${a} of ${b} products`,
    sorts: { relevance: 'Relevance', price_asc: 'Price, low to high', price_desc: 'Price, high to low', newest: 'Newest', discount: 'Biggest discount' },
    facets: { available: 'Availability', onlyAvailable: 'In stock only', onSale: 'On sale only', price: 'Price', age: 'Age', vendor: 'Brand', categories: 'Category', colors: 'Colour', labels: 'Labels' },
    showAll: 'Show all', showLess: 'Show less', searchBrand: 'Search brand …', from: 'from', to: 'to', apply: 'OK',
    semanticInfo: (q) => `No exact matches for “${q}” – these products are the closest fit.`,
    relaxedInfo: 'Few results matched every criterion – we added similar products.',
    zeroTitle: (q) => `Nothing found for “${q}”`, zeroHint: 'Maybe one of these helps:', related: 'Related categories', removeChip: 'remove',
  },
};
const T = STRINGS[LANG] || STRINGS.de;

const COLOR_HEX = { Schwarz: '#1d1d1b', Weiss: '#ffffff', Grau: '#9a9a9a', Beige: '#dccbb0', Braun: '#8a5a3c', Blau: '#3b6ea8', Grün: '#5f8f61', Gelb: '#f2cf4a', Orange: '#ee8a3c', Rot: '#c8413a', Rosa: '#efb3c4', Lila: '#8b6bb1', Bunt: 'conic-gradient(#c8413a,#f2cf4a,#5f8f61,#3b6ea8,#8b6bb1,#c8413a)', Gold: 'linear-gradient(135deg,#b8902f,#f3dc8b,#b8902f)', Silber: 'linear-gradient(135deg,#9ea3a8,#eef0f2,#9ea3a8)', Natur: '#e9dcc3' };
const COLOR_LABEL = { de: {}, fr: { Schwarz: 'Noir', Weiss: 'Blanc', Grau: 'Gris', Beige: 'Beige', Braun: 'Marron', Blau: 'Bleu', Grün: 'Vert', Gelb: 'Jaune', Orange: 'Orange', Rot: 'Rouge', Rosa: 'Rose', Lila: 'Violet', Bunt: 'Multicolore', Gold: 'Or', Silber: 'Argent', Natur: 'Naturel' }, en: { Schwarz: 'Black', Weiss: 'White', Grau: 'Grey', Beige: 'Beige', Braun: 'Brown', Blau: 'Blue', Grün: 'Green', Gelb: 'Yellow', Orange: 'Orange', Rot: 'Red', Rosa: 'Pink', Lila: 'Purple', Bunt: 'Multicolour', Gold: 'Gold', Silber: 'Silver', Natur: 'Natural' } };
const colorName = (c) => COLOR_LABEL[LANG]?.[c] || c;

// ------------------------------------------------------------------ Helfer
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const money = (v) => {
  try { return new Intl.NumberFormat(`${LANG}-CH`, { style: 'currency', currency: CFG?.currency || 'CHF', minimumFractionDigits: 2 }).format(v); } catch { return `CHF ${Number(v).toFixed(2)}`; }
};
const img = (src, w) => (src ? `${src}${src.includes('?') ? '&' : '?'}width=${w}` : '');
const srcset = (src, widths) => widths.map((w) => `${img(src, w)} ${w}w`).join(', ');
const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
const localeUrl = (url) => url; // URLs kommen bereits lokalisiert aus der API

// Sitzung wie bei Shopify (vergleichbare Kennzahlen): gilt über alle Tabs, endet nach 30 Min. ohne Seitenaufruf.
// Jeder Seitenaufruf verlängert sie (nur lokal im Browser, keine Anfrage an den Server).
const SID_KEY = 'cdx-search-session';
const SESSION_MS = 30 * 60_000;
const readSession = () => { try { return JSON.parse(localStorage.getItem(SID_KEY) || 'null'); } catch { return null; } };
const sid = (() => {
  try {
    let s = readSession();
    if (!s?.id || Date.now() - s.t > SESSION_MS) s = { id: Math.random().toString(36).slice(2, 12), terms: [] };
    s.t = Date.now();
    localStorage.setItem(SID_KEY, JSON.stringify(s));
    return s.id;
  } catch { return null; }
})();
const sessionTerms = () => { const s = readSession(); return s?.id === sid ? s.terms || [] : []; };

async function api(path, params = {}, { signal, timeout = 3500 } = {}) {
  const url = new URL(`${CFG.endpoint}${path}`, location.origin);
  for (const [k, v] of Object.entries(params)) {
    if (v == null || v === '' || (Array.isArray(v) && !v.length)) continue;
    url.searchParams.set(k, Array.isArray(v) ? v.join('|') : v);
  }
  url.searchParams.set('locale', LANG);
  const ac = new AbortController();
  let timedOut = false;
  const timer = setTimeout(() => { timedOut = true; ac.abort(); }, timeout);
  signal?.addEventListener('abort', () => ac.abort());
  try {
    const res = await fetch(url, { signal: ac.signal, headers: { Accept: 'application/json' } });
    if (res.status >= 500) markDown();
    if (!res.ok) throw Object.assign(new Error(`HTTP ${res.status}`), { http: res.status });
    return await res.json();
  } catch (e) {
    if (!e.http && (timedOut || e.name !== 'AbortError')) markDown(); // Netzwerkfehler/Timeout, nicht: vom Nutzer abgebrochen
    throw e;
  } finally { clearTimeout(timer); }
}

// Server nicht erreichbar → 5 Minuten lang direkt Shopify-Suche (siehe snippets/cdx-search-config)
function markDown() { try { sessionStorage.setItem('cdx-search-down', String(Date.now())); } catch { /* egal */ } }

function track(event) {
  if (!CFG) return;
  const body = JSON.stringify({ ...event, session: sid, customer: CFG.customer || undefined, locale: LANG });
  try { navigator.sendBeacon(`${CFG.endpoint}/api/e`, new Blob([body], { type: 'text/plain' })); } catch { /* egal */ }
  if (event.q && event.type !== 'cart') rememberSearch(event.q);
}

// Suche → Bestellung: Session-ID und die letzten Suchbegriffe als versteckte Warenkorb-Attribute.
// Shopify übernimmt sie in die Bestellung; die App ordnet den Kauf so der Such-Session zu.
function rememberSearch(q) {
  q = String(q || '').trim();
  if (!q || !sid || q.startsWith('similar:')) return;
  const terms = [...sessionTerms().filter((t) => t.toLowerCase() !== q.toLowerCase()), q].slice(-5);
  try { localStorage.setItem(SID_KEY, JSON.stringify({ id: sid, t: Date.now(), terms })); } catch { /* egal */ }
  setCartAttributes(terms);
}
function setCartAttributes(terms) {
  fetch(`${(CFG.root || '/').replace(/\/$/, '')}/cart/update.js`, {
    method: 'POST', keepalive: true,
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { _cdx_sid: sid, _cdx_suche: terms.join(' · ') } }),
  }).catch(() => { /* egal */ });
}

// Zuletzt gesucht (nur lokal im Browser)
const RECENT_KEY = 'cdx-search-recent';
const recent = {
  get() { try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch { return []; } },
  add(q) { q = q.trim(); if (!q) return; try { localStorage.setItem(RECENT_KEY, JSON.stringify([q, ...this.get().filter((x) => x.toLowerCase() !== q.toLowerCase())].slice(0, 6))); } catch { /* egal */ } },
  clear() { try { localStorage.removeItem(RECENT_KEY); } catch { /* egal */ } },
};

const searchUrl = (q) => `${CFG?.searchUrl || '/search'}?q=${encodeURIComponent(q)}&type=product`;

const ICON_SEARCH = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3-3"/></svg>';
const ICON_CLOCK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
const ICON_SPARK = '<svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor" aria-hidden="true"><path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z"/></svg>';
const ICON_X = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
const ICON_ARROW = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>';

const swatchStyle = (c) => (COLOR_HEX[c] ? `background:${COLOR_HEX[c]}` : '');

// ==================================================================== Instant-Suche im Header
class CdxInstantSearch extends HTMLElement {
  connectedCallback() {
    let sib = this.previousElementSibling;
    while (sib && sib.tagName !== 'FORM') sib = sib.previousElementSibling;
    this.form = sib || this.closest('form');
    this.input = this.form?.querySelector('input[type="search"], input[name="q"]');
    if (!this.input) return;
    this.menuMap = readJson('ps-collection-menu-map') || {};
    this.menuLabels = readJson('ps-menu-labels') || {};
    this.menuOrder = readJson('ps-menu-order') || [];
    this.innerHTML = '<div class="predictive-search__panel cdx-ps" hidden role="region"><div class="predictive-search__body"></div></div>';
    this.panel = this.firstElementChild;
    this.body = this.panel.firstElementChild;
    this.input.setAttribute('aria-autocomplete', 'list');
    this.active = -1;
    this.last = null;

    this.input.addEventListener('input', debounce(() => this.update(), 110));
    this.input.addEventListener('focus', () => this.update(true));
    this.input.addEventListener('keydown', (e) => this.onKey(e));
    this.form.addEventListener('reset', () => { this.last = null; setTimeout(() => { this.input.focus(); this.update(true); }, 0); });
    this.form.addEventListener('submit', (e) => this.onSubmit(e));
    this.body.addEventListener('click', (e) => this.onClick(e));
    document.addEventListener('click', (e) => { if (!this.panel.hidden && !this.contains(e.target) && !this.form.contains(e.target)) this.close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.panel.hidden) { this.close(); this.input.blur(); } });
  }

  open() { if (this.panel.hidden) { this.panel.hidden = false; this.classList.add('is-open'); this.input.setAttribute('aria-expanded', 'true'); } }
  close() { if (!this.panel.hidden) { this.panel.hidden = true; this.classList.remove('is-open'); this.input.setAttribute('aria-expanded', 'false'); this.active = -1; } }

  async update(fromFocus = false) {
    const q = this.input.value.trim();
    if (q === this.last && !fromFocus) return;
    if (q === this.last && fromFocus && this.body.innerHTML) { this.open(); return; }
    this.last = q;
    this.ac?.abort();
    this.ac = new AbortController();
    if (!q) {
      try { this.render(await api('/api/discover', {}, { signal: this.ac.signal }), ''); } catch (e) { if (e.name !== 'AbortError') this.renderRecentOnly(); }
      return;
    }
    if (!this.body.querySelector('.cdx-ps__product')) this.renderLoading();
    this.open();
    try {
      const data = await api('/api/suggest', { q }, { signal: this.ac.signal });
      if (this.input.value.trim() !== q) return;
      this.data = data;
      this.render(data, q);
    } catch (e) {
      if (e.name === 'AbortError' && this.input.value.trim() !== q) return;
      this.fallback(q);
    }
  }

  renderLoading() {
    let s = '<div class="predictive-search__loading" aria-hidden="true">';
    for (let i = 0; i < 4; i++) s += '<div class="predictive-search__skel"><span class="predictive-search__skel-img"></span><div class="predictive-search__skel-lines"><span class="predictive-search__skel-line"></span><span class="predictive-search__skel-line predictive-search__skel-line--sm"></span></div></div>';
    this.body.innerHTML = `${s}</div>`;
    this.open();
  }

  renderRecentOnly() {
    const r = recent.get();
    if (!r.length) { this.close(); return; }
    this.body.innerHTML = `<div class="predictive-search__sections">${this.recentHtml(r)}</div>`;
    this.open();
  }

  recentHtml(r) {
    if (!r.length) return '';
    return `<section class="predictive-search__section"><h3 class="predictive-search__heading cdx-ps__heading-row">${T.recent}<button type="button" class="cdx-ps__clear" data-clear-recent>${T.clear}</button></h3>
      <ul class="predictive-search__pills" role="list">${r.map((q) => `<li><a href="${esc(searchUrl(q))}" class="predictive-search__pill cdx-ps__pill--recent" data-ps-item data-q="${esc(q)}">${ICON_CLOCK}${esc(q)}</a></li>`).join('')}</ul></section>`;
  }

  productHtml(p, i, q) {
    const onSale = p.compareAt && p.compareAt > p.price;
    const swatches = p.swatches?.length > 1 ? `<span class="cdx-ps__swatches">${p.swatches.slice(0, 5).map((s) => `<i style="${swatchStyle(s.color)}"></i>`).join('')}${p.swatches.length > 5 ? `<em>+${p.swatches.length - 5}</em>` : ''}</span>` : '';
    return `<li><a href="${esc(p.url)}" class="predictive-search__product cdx-ps__product${p.available ? '' : ' is-sold-out'}" data-ps-item data-pid="${p.id}" data-pos="${i + 1}">
      <div class="predictive-search__product-img">${p.image ? `<img src="${esc(img(p.image, 160))}" alt="" loading="lazy" width="80" height="80">` : ''}${onSale ? `<span class="predictive-search__badge">-${p.discount}%</span>` : ''}</div>
      <div class="predictive-search__product-info">
        ${p.vendor ? `<span class="predictive-search__vendor">${esc(p.vendor)}</span>` : ''}
        <span class="predictive-search__product-title">${highlight(p.title, q)}</span>
        <span class="predictive-search__price">${onSale ? `<span class="predictive-search__price-was">${money(p.compareAt)}</span>` : ''}<span class="predictive-search__price-now${onSale ? ' predictive-search__price-now--sale' : ''}">${p.priceMax > p.price ? `${T.from === 'von' ? 'ab' : T.from} ` : ''}${money(p.price)}</span>${p.available ? '' : `<span class="cdx-ps__soldout">${T.soldOut}</span>`}</span>
        ${swatches}
      </div></a></li>`;
  }

  collectionsHtml(collections, q) {
    if (!collections.length) return '';
    const groups = {};
    for (const c of collections) {
      const path = new URL(c.url, location.origin).pathname.replace(/^\/(fr|en)\//, '/');
      const prefix = this.menuMap[path] || this.menuMap[c.url] || '_other';
      (groups[prefix] ??= []).push(c);
    }
    const order = [...this.menuOrder.filter((p) => groups[p]), ...Object.keys(groups).filter((p) => !this.menuOrder.includes(p))];
    const pill = (c) => `<li><a href="${esc(c.url)}" class="predictive-search__pill" data-ps-item>${highlight(c.title, q)}</a></li>`;
    let html = `<section class="predictive-search__section"><h3 class="predictive-search__heading">${T.collections}</h3>`;
    if (order.length > 1) {
      html += '<div class="predictive-search__groups">';
      for (const p of order) html += `<div class="predictive-search__group"><span class="predictive-search__group-label">${esc(p === '_other' ? '' : (this.menuLabels[p] || p))}</span><ul class="predictive-search__pills" role="list">${groups[p].slice(0, 6).map(pill).join('')}</ul></div>`;
      html += '</div>';
    } else {
      html += `<ul class="predictive-search__pills" role="list">${collections.slice(0, 8).map(pill).join('')}</ul>`;
    }
    return `${html}</section>`;
  }

  render(data, q) {
    this.active = -1;
    if (data.redirect) this.redirect = data.redirect; else this.redirect = null;
    let html = '<div class="predictive-search__sections">';

    if (!q) { // Leeres Feld: Inspiration
      html += this.recentHtml(recent.get());
      if (data.popular?.length) html += `<section class="predictive-search__section"><h3 class="predictive-search__heading">${T.popular}</h3><ul class="predictive-search__pills" role="list">${data.popular.map((p) => `<li><a href="${esc(searchUrl(p))}" class="predictive-search__pill" data-ps-item data-q="${esc(p)}">${esc(p)}</a></li>`).join('')}</ul></section>`;
      if (data.products?.length) html += `<section class="predictive-search__section predictive-search__section--products"><h3 class="predictive-search__heading">${T.newIn}</h3><ul class="predictive-search__products" role="list">${data.products.map((p, i) => this.productHtml(p, i, '')).join('')}</ul></section>`;
      this.body.innerHTML = `${html}</div>`;
      this.open();
      return;
    }

    const total = (data.products?.length || 0) + (data.collections?.length || 0) + (data.queries?.length || 0) + (data.content?.length || 0);
    if (!total) {
      this.body.innerHTML = `<div class="predictive-search__empty"><p class="predictive-search__empty-title">${T.noResults} „${esc(q)}“</p><p class="predictive-search__empty-hint">${T.noResultsHint}</p></div>`;
      this.open();
      return;
    }

    if (data.nlu?.chips?.length) {
      html += `<div class="cdx-ps__understood">${ICON_SPARK}<span>${T.understood}:</span>${data.nlu.chips.map((c) => `<span class="cdx-chip cdx-chip--static">${esc(chipLabel(c))}</span>`).join('')}</div>`;
    }
    if (data.queries?.length) {
      html += `<section class="predictive-search__section"><h3 class="predictive-search__heading">${T.suggestions}</h3><ul class="predictive-search__suggestions" role="list">`;
      html += data.queries.slice(0, 5).map((s) => `<li><a href="${esc(searchUrl(s.text))}" class="predictive-search__suggestion" data-ps-item data-q="${esc(s.text)}">${ICON_SEARCH}<span>${s.html.replace(/<(?!\/?mark>)[^>]+>/g, '')}</span>${s.type === 'brand' ? `<em class="cdx-ps__type">${T.facets.vendor}</em>` : s.type === 'category' ? `<em class="cdx-ps__type">${T.facets.categories}</em>` : ''}</a></li>`).join('');
      html += '</ul></section>';
    }
    html += this.collectionsHtml(data.collections || [], q);
    if (data.products?.length) {
      html += `<section class="predictive-search__section predictive-search__section--products"><h3 class="predictive-search__heading">${T.products}</h3><ul class="predictive-search__products" role="list">${data.products.slice(0, 8).map((p, i) => this.productHtml(p, i, q)).join('')}</ul></section>`;
    }
    if (data.content?.length) {
      html += `<section class="predictive-search__section"><h3 class="predictive-search__heading">${T.pages}</h3><ul class="predictive-search__pages" role="list">${data.content.map((c) => `<li><a href="${esc(c.url)}" class="predictive-search__page" data-ps-item>${highlight(c.title, q)}</a></li>`).join('')}</ul></section>`;
    }
    html += '</div>';
    html += `<div class="predictive-search__footer"><a href="${esc(searchUrl(q))}" class="predictive-search__view-all" data-ps-item data-view-all>${T.viewAll} „${esc(q)}“${data.total ? ` (${data.total})` : ''}${ICON_ARROW}</a></div>`;
    this.body.innerHTML = html;
    this.open();
  }

  onClick(e) {
    if (e.target.closest('[data-clear-recent]')) { e.preventDefault(); recent.clear(); this.last = null; this.update(true); return; }
    const a = e.target.closest('a');
    if (!a) return;
    const q = this.input.value.trim();
    if (a.dataset.q) recent.add(a.dataset.q);
    else if (q) recent.add(q);
    if (a.dataset.pid) track({ type: 'click', q, productId: a.dataset.pid, position: Number(a.dataset.pos), source: 'instant' });
  }

  onSubmit(e) {
    const q = this.input.value.trim();
    if (!q) { e.preventDefault(); return; }
    recent.add(q);
    if (this.redirect && this.data?.q === q) {
      e.preventDefault();
      track({ type: 'redirect', q });
      location.href = this.redirect;
    }
  }

  onKey(e) {
    if (this.panel.hidden) return;
    const items = [...this.body.querySelectorAll('[data-ps-item]')];
    if (e.key === 'Enter' && this.active >= 0 && items[this.active]) { e.preventDefault(); items[this.active].click(); return; }
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    if (!items.length) return;
    e.preventDefault();
    this.active = e.key === 'ArrowDown' ? (this.active + 1) % items.length : (this.active - 1 + items.length) % items.length;
    items.forEach((el, i) => el.toggleAttribute('data-ps-active', i === this.active));
    items[this.active].scrollIntoView({ block: 'nearest' });
  }

  // App nicht erreichbar → Shopify Predictive Search (wie bisher)
  async fallback(q) {
    try {
      const p = new URLSearchParams({ q, 'resources[type]': 'product,collection,query', 'resources[limit]': '6', 'resources[limit_scope]': 'each' });
      const res = await fetch(`${CFG.root}search/suggest.json?${p}`);
      const r = (await res.json()).resources.results;
      this.render({
        products: (r.products || []).map((x) => ({ id: x.id, url: x.url, title: x.title, vendor: x.vendor, image: x.image || x.featured_image?.url, price: parseFloat(x.price), priceMax: parseFloat(x.price_max || x.price), compareAt: parseFloat(x.compare_at_price_max) || null, discount: 0, available: x.available !== false })),
        collections: (r.collections || []).map((c) => ({ title: c.title, url: c.url })),
        queries: (r.queries || []).map((x) => ({ text: x.text, html: x.styled_text || esc(x.text) })),
      }, q);
    } catch { this.close(); }
  }
}

function readJson(id) { try { return JSON.parse(document.getElementById(id)?.textContent || 'null'); } catch { return null; } }

function highlight(text, q) {
  const safe = esc(text);
  const words = String(q || '').trim().split(/\s+/).filter((w) => w.length >= 2).map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  if (!words.length) return safe;
  return safe.replace(new RegExp(`(${words.join('|')})`, 'gi'), '<mark class="predictive-search__mark">$1</mark>');
}

function chipLabel(c) {
  if (c.key === 'colors') return c.label.split(' / ').map(colorName).join(' / ');
  return c.label;
}

// ==================================================================== Ergebnisseite (Look = Collection-Grid)
const FACET_KEYS = ['vendor', 'sizes', 'farbe', 'alterVon', 'alterBis', 'categories', 'colors', 'labels', 'age'];
const PER_PAGE = 24;
const IS_LOCAL_DEV = /^(127\.0\.0\.1|localhost)$/.test(location.hostname);
const ICON_CHEVRON = '<span class="circle-chevron group-expanded:rotate"><svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small reverse-icon" viewBox="0 0 8 6"><path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path></svg></span>';
const ICON_CHEVRON_ACC = '<span class="circle-chevron group-hover:colors group-expanded:colors group-expanded:rotate"><svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6"><path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path></svg></span>';
const ICON_FILTER = '<svg role="presentation" fill="none" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-filter" viewBox="0 0 20 14"><path d="M1 2C0.447715 2 0 2.44772 0 3C0 3.55228 0.447715 4 1 4V2ZM1 4H5V2H1V4Z" fill="currentColor"></path><path d="M1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12V10ZM1 12H11V10H1V12Z" fill="currentColor"></path><path d="M10 2H9V4H10V2ZM19 4C19.5523 4 20 3.55228 20 3C20 2.44772 19.5523 2 19 2V4ZM10 4H19V2H10V4Z" fill="currentColor"></path><path d="M16 10H15V12H16V10ZM19 12C19.5523 12 20 11.5523 20 11C20 10.4477 19.5523 10 19 10V12ZM16 12H19V10H16V12Z" fill="currentColor"></path><circle cx="7" cy="3" r="2" stroke="currentColor"></circle><circle cx="13" cy="11" r="2" stroke="currentColor"></circle></svg>';
const CLEAR_X = 'https://cdn.shopify.com/s/files/1/0882/1771/5015/files/cil-x.png?v=1743043019';
const SORT_KEYS = ['relevance', 'bestseller', 'price_asc', 'price_desc', 'newest', 'discount', 'title_asc'];

// ---- Produktkarten 1:1 vom Theme (sections/cdx-search-cards → snippet product-card)
const cardCache = new Map();
const injectedStyles = new Set();
async function themeCards(handles, signal) {
  const missing = handles.filter((h) => !cardCache.has(h));
  const chunks = [];
  for (let i = 0; i < missing.length; i += 12) chunks.push(missing.slice(i, i + 12));
  await Promise.all(chunks.map(async (chunk) => {
    const url = `${CFG.root}search?q=${encodeURIComponent(chunk.join(' '))}&type=product&section_id=cdx-search-cards`;
    const res = await fetch(url, { signal });
    if (!res.ok) throw new Error(`cards ${res.status}`);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    doc.querySelectorAll('style').forEach((st) => {
      const key = st.textContent.trim().slice(0, 200);
      if (injectedStyles.has(key)) return;
      injectedStyles.add(key);
      document.head.appendChild(document.importNode(st, true));
    });
    doc.querySelectorAll('product-card[handle]').forEach((el) => { if (!cardCache.has(el.getAttribute('handle'))) cardCache.set(el.getAttribute('handle'), el.outerHTML); });
    chunk.forEach((h) => { if (!cardCache.has(h)) cardCache.set(h, null); });
  }));
  return handles.map((h) => cardCache.get(h));
}

class CdxSearchResults extends HTMLElement {
  connectedCallback() {
    if (!CFG?.resultsPage) return;
    this.state = this.readUrl();
    this.hits = [];
    this.addEventListener('click', (e) => this.onClick(e));
    this.addEventListener('change', (e) => this.onChange(e));
    this.addEventListener('listbox:change', (e) => { e.stopPropagation(); this.state.sort = e.detail.value; this.refresh(); });
    window.addEventListener('popstate', () => { this.state = this.readUrl(); this.load({ replace: true }); });
    this.load({ initial: true });
  }

  readUrl() {
    const sp = new URLSearchParams(location.search);
    const s = { q: sp.get('q') || '', sort: sp.get('sort_by_cdx') || 'relevance', ui: {}, ignore: (sp.get('cdx_ignore') || '').split('|').filter(Boolean) };
    for (const k of FACET_KEYS) { const v = sp.get(`cdx_${k}`); if (v) s.ui[k] = v.split('|'); }
    if (sp.get('cdx_price')) s.ui.price = sp.get('cdx_price');
    if (sp.get('cdx_onSale') === '1') s.ui.onSale = true;
    if (sp.get('cdx_available') === '1') s.ui.available = true;
    s.pages = Math.max(1, Number(sp.get('cdx_page')) || 1);
    return s;
  }

  writeUrl(push) {
    const sp = new URLSearchParams();
    sp.set('q', this.state.q);
    sp.set('type', 'product');
    if (this.state.sort !== 'relevance') sp.set('sort_by_cdx', this.state.sort);
    for (const k of FACET_KEYS) if (this.state.ui[k]?.length) sp.set(`cdx_${k}`, this.state.ui[k].join('|'));
    if (this.state.ui.price) sp.set('cdx_price', this.state.ui.price);
    if (this.state.ui.onSale) sp.set('cdx_onSale', '1');
    if (this.state.ui.available) sp.set('cdx_available', '1');
    if (this.state.ignore.length) sp.set('cdx_ignore', this.state.ignore.join('|'));
    if (this.state.pages > 1) sp.set('cdx_page', String(this.state.pages));
    history[push ? 'pushState' : 'replaceState'](null, '', `${location.pathname}?${sp}`);
  }

  params(page) {
    const ui = this.state.ui;
    return {
      q: this.state.q, page, perPage: PER_PAGE, sort: this.state.sort,
      vendor: ui.vendor, sizes: ui.sizes, farbe: ui.farbe, alterVon: ui.alterVon, alterBis: ui.alterBis, categories: ui.categories, colors: ui.colors, labels: ui.labels, age: ui.age,
      price: ui.price, onSale: ui.onSale ? 1 : null, available: ui.available ? 1 : null,
      ignore: this.state.ignore, sid, cid: CFG.customer || null,
    };
  }

  async load({ initial = false, append = false, push = false } = {}) {
    this.ac?.abort();
    this.ac = new AbortController();
    const signal = this.ac.signal;
    this.classList.add('is-loading');
    try {
      let data, newHits;
      if (append) {
        data = await api('/api/search', this.params(this.data.page + 1), { signal, timeout: 6000 });
        newHits = data.hits;
        this.state.pages = data.page;
      } else {
        const pages = this.state.pages || 1;
        data = await api('/api/search', { ...this.params(1), track: initial ? 1 : null }, { signal, timeout: initial ? 8000 : 6000 });
        if (initial && data.q) rememberSearch(data.q);
        newHits = data.hits;
        for (let p = 2; p <= Math.min(pages, data.pages); p++) {
          const more = await api('/api/search', this.params(p), { signal });
          newHits = [...newHits, ...more.hits]; data.page = p;
        }
        if (initial && data.redirect && !Object.keys(this.state.ui).length && !new URLSearchParams(location.search).has('cdx_noredirect')) {
          track({ type: 'redirect', q: data.q });
          location.replace(data.redirect);
          return;
        }
      }
      const cards = await this.buildCards(newHits, append ? this.hits.length : 0, signal);
      this.data = data;
      if (append) { this.hits.push(...newHits); this.appendCards(cards); this.writeUrl(false); this.renderMore(); }
      else { this.hits = newHits; if (!initial) this.writeUrl(push); this.render(cards); }
      document.documentElement.classList.add('cdx-search-ready');
    } catch (e) {
      if (e.name === 'AbortError' && !initial) return;
      console.warn('[cdx-search] Fallback auf Shopify-Suche:', e);
      if (initial) document.documentElement.classList.add('cdx-search-failed');
    } finally {
      if (!signal.aborted) this.classList.remove('is-loading');
    }
  }

  // Theme-Karten holen; falls das nicht klappt, eigene Karte im selben Markup
  async buildCards(hits, offset, signal) {
    let html;
    try { html = await themeCards(hits.map((h) => h.handle), signal); } catch (e) { if (e.name === 'AbortError') throw e; html = []; }
    return hits.map((h, i) => {
      const tpl = document.createElement('template');
      tpl.innerHTML = (html[i] || cardHtml(h, offset + i)).trim();
      const card = tpl.content.firstElementChild;
      card.dataset.pid = h.id;
      card.dataset.pos = offset + i + 1;
      // Nur lokale Vorschau (shopify theme dev): zeigt Produkte fälschlich als ausverkauft → echte Verfügbarkeit.
      // Im Shop bleibt die Karte unverändert wie im Collection-Grid.
      if (IS_LOCAL_DEV && h.available) card.querySelectorAll('sold-out-badge, .badge--sold-out').forEach((b) => b.remove());
      // Produktfamilie (andere Farben = eigene Produkte) als Farbpunkte unter der Karte
      if (html[i] && h.swatches?.length > 1) {
        const info = card.querySelector('.product-card__info');
        info?.insertAdjacentHTML('beforeend', `<ul class="cdx-card__swatches" role="list">${h.swatches.slice(0, 6).map((s, j) => `<li><a href="${esc(s.url)}" class="cdx-card__swatch${j === 0 ? ' is-current' : ''}${s.available ? '' : ' is-sold-out'}" title="${esc(s.label)}" data-swatch-img="${esc(img(s.image, 600))}" style="${swatchStyle(s.color)}"></a></li>`).join('')}${h.swatches.length > 6 ? `<li class="cdx-card__swatch-more">+${h.swatches.length - 6}</li>` : ''}</ul>`);
        card.classList.add('cdx-card');
      }
      return card;
    });
  }

  appendCards(cards) { this.querySelector('product-list')?.append(...cards); }

  // ---------------------------------------------------------------- Rendering
  render(cards) {
    const d = this.data;
    const openDialog = this.querySelector('facet-dialog[open]')?.id;
    // Fester Platz für den Drawer: das Theme hängt ihn nach dem Schliessen an seinen alten Container zurück
    if (!this.view) {
      this.innerHTML = '<div data-cdx-view></div><div data-cdx-drawer-host></div>';
      this.view = this.firstElementChild;
      this.drawerHost = this.lastElementChild;
    }
    let info = '';
    if (d.total && d.info.mode === 'semantic-fallback') info = `<p class="cdx-sr__info">${ICON_SPARK}${esc(T.semanticInfo(d.q))}</p>`;
    else if (d.total && d.info.relaxed?.length) info = `<p class="cdx-sr__info">${ICON_SPARK}${esc(T.relaxedInfo)}</p>`;
    const seenTitles = new Set();
    const colls = (d.collections || []).filter((c) => { const k = c.title.toLowerCase(); return seenTitles.has(k) ? false : seenTitles.add(k); });
    const related = colls.length || d.content?.length ? `<div class="cdx-sr__related">
        <span class="cdx-sr__related-label">${T.related}</span><ul class="cdx-pills" role="list">${colls.slice(0, 10).map((c) => `<li><a class="cdx-pill" href="${esc(c.url)}">${esc(c.title)}</a></li>`).join('')}${(d.content || []).map((c) => `<li><a class="cdx-pill cdx-pill--page" href="${esc(c.url)}">${esc(c.title)}</a></li>`).join('')}</ul>
      </div>` : '';
    const hasFilters = this.activeFilterCount() > 0;
    const noResults = !d.total;

    this.view.innerHTML = `
      <div class="cdx-sr">
        <header class="cdx-sr__header">
          <h1 class="h2 cdx-sr__title">${T.title}</h1>
          <form class="cdx-sr__form" role="search" data-search-form>
            <input type="search" name="q" value="${esc(d.q)}" aria-label="${esc(T.title)}" autocomplete="off" autocorrect="off" spellcheck="false">
            <button type="submit" aria-label="${esc(T.title)}">${ICON_SEARCH.replace(/14/g, '20')}</button>
          </form>
          ${this.nluChipsHtml(d)}
          ${related}
        </header>
        ${noResults && !hasFilters ? this.zeroHtml(d) : `
        <div class="collection collection--filters-horizontal">
          ${this.topBarHtml(d)}
          <facet-floating-filter class="facets__floating-filter md:hidden">
            <button type="button" class="button button--xl" style="--button-background: 21 50 53 / var(--button-background-opacity, 1);--button-outline-color: 21 50 53;--button-text-color: 255 255 255;" aria-controls="cdx-facets-drawer" aria-expanded="false" is="custom-button">
              <div class="text-with-icon justify-center">${ICON_FILTER}${T.ui.filterAndSort}</div>
            </button>
          </facet-floating-filter>
          <div class="collection__results">
            ${info}
            ${noResults ? `<div class="empty-state"><div class="empty-state__icon-wrapper"><span class="count-bubble count-bubble--lg">0</span></div><div class="prose"><p class="h5">${esc(T.ui.noFilterResults)}</p><button type="button" class="button button--xl" data-reset>${esc(T.ui.clearAll)}</button></div></div>` : `
            <div class="v-stack gap-6">
              <div class="v-stack gap-4 md:hidden"><p class="text-center product-count-mobile">${esc(T.ui.count(d.total))}</p></div>
              <product-list class="product-list" role="region" aria-live="polite"></product-list>
            </div>`}
          </div>
          <div id="cdx-infinite-wrap">
            <div class="cdx-infinite-loader" hidden><svg width="32" height="32" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#ecf3f3" stroke-width="3"/><path d="M12 2a10 10 0 019.8 8" stroke="#3a8d95" stroke-width="3" stroke-linecap="round"/></svg></div>
            <div class="cdx-infinite-sentinel"></div>
            <div class="cdx-sr__more"></div>
          </div>
        </div>`}
      </div>`;

    this.appendCards(cards);
    if (openDialog) this.querySelector(`#${CSS.escape(openDialog)}`)?.setAttribute('open', '');
    if (d.total || this.activeFilterCount()) this.ensureDrawer(d.facets);
    this.renderMore();
  }

  renderMore() {
    const d = this.data;
    const more = this.querySelector('.cdx-sr__more');
    if (!more) return;
    const left = this.hits.length < d.total;
    more.innerHTML = left ? `<button type="button" class="button button--outline" data-more>${T.more}</button>` : '';
    this.observer?.disconnect();
    if (!left) return;
    this.observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting || this.classList.contains('is-loading')) return;
      this.querySelector('.cdx-infinite-loader').hidden = false;
      this.load({ append: true });
    }, { rootMargin: '600px 0px' });
    this.observer.observe(this.querySelector('.cdx-infinite-sentinel'));
  }

  nluChipsHtml(d) {
    if (!d.nlu?.chips?.length) return '';
    return `<div class="cdx-sr__chips"><span class="cdx-sr__chips-label">${T.understood}:</span>${d.nlu.chips.map((c) => `<button type="button" class="cdx-chip cdx-chip--nlu" data-ignore="${esc(c.key)}" title="${esc(T.removeChip)}">${ICON_SPARK}${esc(chipLabel(c))}${ICON_X}</button>`).join('')}</div>`;
  }

  // Filtergruppen in Collection-Reihenfolge: Preis, Marke, Grösse, Farben, Alter (von), Alter (bis), dann Kategorie, Labels, Angebote
  groups(f) {
    // Exakt die Filter des Collection-Grids, in derselben Reihenfolge: Preis, Marke, Grösse, Farben, Alter (von), Alter (bis)
    const list = (key, label, vals, lab = (v) => v.value) => (vals?.length ? { key, label, values: vals.map((v) => ({ value: v.value, label: lab(v) })) } : null);
    return [
      f.price && f.price.max > f.price.min ? { key: 'price', label: T.facetNames.price, type: 'price' } : null,
      list('vendor', T.facetNames.vendor, f.vendor),
      list('sizes', T.facetNames.sizes, f.sizes),
      // Farben aus der Farbpalette (Metafeld) wie im Shop; nur ohne Metafeld-Daten aus dem Katalog abgeleitet
      f.farbe?.length ? list('farbe', T.facetNames.colors, f.farbe) : list('colors', T.facetNames.colors, f.colors, (v) => colorName(v.value)),
      list('alterVon', T.facetNames.alterVon, f.alterVon),
      list('alterBis', T.facetNames.alterBis, f.alterBis),
    ].filter(Boolean);
  }

  activeCount(key) {
    const ui = this.state.ui;
    if (key === 'price') return ui.price ? 1 : 0;
    if (key === 'onSale') return ui.onSale ? 1 : 0;
    return ui[key]?.length || 0;
  }

  checkbox(prefix, key, v, checked, type = 'checkbox', name) {
    const id = `${prefix}-${key}-${String(v.value).toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
    const attr = key === 'onSale' ? 'data-flag="onSale"' : key === 'sort' ? 'data-sort-radio' : `data-facet-key="${key}"`;
    return `<div class="checkbox-container"><input id="${id}" class="checkbox" type="${type}" name="${esc(name || key)}" value="${esc(v.value)}" ${attr} ${checked ? 'checked' : ''}><label for="${id}">${esc(v.label)}</label></div>`;
  }

  priceRange(f, inline, prefix) {
    const p = f.price;
    const [a, b] = (this.state.ui.price || '').split('-');
    const lo = a ? Number(a) : p.min, hi = b ? Number(b) : p.max;
    const pct = (x) => `${(((x - p.min) / Math.max(1, p.max - p.min)) * 100).toFixed(1)}%`;
    const field = (name, label, value, ph) => `<label class="input-prefix text-sm"><span class="prefix text-subdued">${esc(CFG.currency || 'CHF')}</span><input aria-label="${esc(label)}" class="field" type="number" inputmode="numeric" name="${name}" id="${prefix}-${name}" min="${p.min}" max="${p.max}" placeholder="${ph}" value="${value ?? ''}" autocomplete="off" data-price-field></label>`;
    const ranges = `<div class="range-group" style="--range-min: ${pct(lo)}; --range-max: ${pct(hi)}"><input type="range" aria-label="${esc(T.facetNames.price)} ${T.from}" class="range" min="${p.min}" max="${p.max}" value="${lo}"><input type="range" aria-label="${esc(T.facetNames.price)} ${T.to}" class="range" min="${p.min}" max="${p.max}" value="${hi}"></div>`;
    const fLo = field('filter.v.price.gte', `${T.facetNames.price} ${T.from}`, a, p.min);
    const fHi = field('filter.v.price.lte', `${T.facetNames.price} ${T.to}`, b, p.max);
    return inline
      ? `<price-range class="price-range price-range--inline">${fLo}${ranges}${fHi}</price-range>`
      : `<price-range class="price-range">${ranges}<div class="input-group">${fLo}${fHi}</div></price-range>`;
  }

  topBarHtml(d) {
    const f = d.facets;
    const ui = this.state.ui;
    const prefix = 'cdx-facets';
    const wrappers = this.groups(f).map((g) => {
      const n = this.activeCount(g.key);
      const dialogId = `cdx-filter-dialog-${g.key}`;
      let body;
      if (g.type === 'price') body = this.priceRange(f, true, prefix);
      else body = `<div class="checkbox-list">${g.values.map((v) => this.checkbox(prefix, g.key, v, g.key === 'onSale' ? ui.onSale : (ui[g.key] || []).includes(v.value))).join('')}</div>`;
      return `<div class="filter-wrapper">
        <button type="button" class="text-with-icon group${n ? ' filter--active' : ''}" aria-controls="${dialogId}" aria-expanded="false">
          <span>${esc(g.label)}</span>
          ${n ? `<span class="filter-count">${n}</span><span class="filter-clear-icon"><a href="#" data-clear-group="${g.key}" aria-label="${esc(T.ui.clearFilter)}" onclick="event.preventDefault();event.stopPropagation();this.closest('cdx-search-results').clearGroup('${g.key}')"><img src="${CLEAR_X}" alt="x"></a></span>` : ICON_CHEVRON}
        </button>
        <facet-dialog id="${dialogId}" class="facet-dialog shadow">${body}</facet-dialog>
      </div>`;
    }).join('');

    const sortId = 'cdx-popover-sort-by';
    const sortSel = SORT_KEYS.includes(this.state.sort) ? this.state.sort : 'relevance';
    return `<div class="collection__top-bar">
      <div class="collection__filters-top-row">
        <div class="text-sm font-medium text-subdued">${esc(T.ui.count(d.total))}</div>
        ${this.activeFilterCount() ? `<a href="#" class="facet-clear-all text-subdued" data-reset><span class="link">${esc(T.ui.clearAll)}</span></a>` : ''}
      </div>
      <div class="facets-divider"></div>
      <div class="facets-summary">
        <div class="facets-summary__filters">
          <form class="contents" data-cdx-facets onsubmit="return false">
            <div class="facets-horizontal">${wrappers}</div>
            <div class="facets-summary__sort-row">
              <div class="sort-by-facet">
                <span id="${sortId}-label">${esc(T.ui.sortBy)}:</span>
                <button type="button" class="text-with-icon group" aria-labelledby="${sortId}-label ${sortId}-value" aria-controls="${sortId}" aria-expanded="false">
                  <span id="${sortId}-value" class="reversed-link">${esc(T.sortNames[sortSel])}</span>${ICON_CHEVRON}
                </button>
                <x-popover id="${sortId}" class="popover" close-on-listbox-select anchor-horizontal="end" anchor-vertical="end">
                  <x-listbox class="popover-listbox" aria-owns="${sortId}-value">
                    ${SORT_KEYS.map((k) => `<button type="button" class="popover-listbox__option group" role="option" value="${k}" ${k === sortSel ? 'aria-selected="true"' : ''}><span class="reversed-link">${esc(T.sortNames[k])}</span></button>`).join('')}
                  </x-listbox>
                </x-popover>
              </div>
              <div class="availability-facet">
                <label for="${prefix}-available">${esc(T.ui.availability)}</label>
                <input id="${prefix}-available" type="checkbox" class="switch" data-flag="available" ${ui.available ? 'checked' : ''}>
              </div>
            </div>
            <div class="facets-divider"></div>
          </form>
        </div>
      </div>
    </div>`;
  }

  // Mobil: Filter-Drawer wie auf der Collection (Akkordeons, Sortierung, Verfügbarkeit, "Anwenden")
  drawerHtml(f) {
    const ui = this.state.ui;
    const prefix = 'cdx-facets-drawer';
    const acc = (id, label, content) => `<details id="${id}" class=" accordion group" aria-expanded="false" is="accordion-disclosure"><summary><div class="accordion__toggle bold"><span>${esc(label)}</span>${ICON_CHEVRON_ACC}</div></summary><div class="accordion__content">${content}</div></details>`;
    const sortSel = SORT_KEYS.includes(this.state.sort) ? this.state.sort : 'relevance';
    let html = acc('cdx-accordion-sort-by', T.ui.sortBy, `<div class="checkbox-list">${SORT_KEYS.map((k) => this.checkbox(prefix, 'sort', { value: k, label: T.sortNames[k] }, k === sortSel, 'radio', 'cdx_sort')).join('')}</div>`);
    for (const g of this.groups(f)) {
      const content = g.type === 'price' ? this.priceRange(f, false, prefix)
        : `<div class="checkbox-list">${g.values.map((v) => this.checkbox(prefix, g.key, v, g.key === 'onSale' ? ui.onSale : (ui[g.key] || []).includes(v.value))).join('')}</div>`;
      html += acc(`cdx-accordion-${g.key}`, g.label, content);
    }
    html += `<div class="accordion"><div class="accordion__toggle"><label for="${prefix}-available" class="bold">${esc(T.ui.availability)}</label><input id="${prefix}-available" type="checkbox" class="switch" data-flag="available" ${ui.available ? 'checked' : ''}></div></div>`;
    html += `<div class="facets-drawer__floating-apply"><button type="button" class="button button--xl w-full" data-drawer-apply>${esc(T.ui.apply)}</button></div>`;
    // id="facet-form": der Theme-Drawer reicht beim Schliessen dieses Formular ein → wir übernehmen die Auswahl
    return `<form id="facet-form" class="facets-vertical" data-cdx-drawer onsubmit="return false">${html}</form>`;
  }

  // Der Theme-Drawer hängt sich beim Öffnen an <body> → einmal erzeugen, danach nur das Formular austauschen
  ensureDrawer(f) {
    const formHtml = this.drawerHtml(f);
    if (!this.drawer) {
      const tpl = document.createElement('template');
      tpl.innerHTML = `<facet-drawer header-bordered id="cdx-facets-drawer" class="facets-drawer drawer" open-from="left"><p class="h5" slot="header">${esc(T.ui.filters)}</p>${formHtml}</facet-drawer>`;
      this.drawer = tpl.content.firstElementChild;
      this.drawer.cdxOwner = this;
      this.drawer.addEventListener('click', (e) => {
        if (!e.target.closest('[data-drawer-apply]')) return;
        this.drawer.hide?.();
        this.applyDrawer();
      });
    } else {
      this.drawer.querySelector('[data-cdx-drawer]')?.replaceWith(document.createRange().createContextualFragment(formHtml));
    }
    if (this.drawer.parentElement !== document.body && this.drawer.parentElement !== this.drawerHost) this.drawerHost.append(this.drawer);
  }

  zeroHtml(d) {
    const sugg = ['Holzspielzeug', 'Geschenk zur Geburt', 'Regenjacke', 'Trinkflasche', 'Lernturm', 'Maileg', 'Laufrad', 'Schlafsack'];
    return `<div class="empty-state">
      <div class="empty-state__icon-wrapper"><span class="count-bubble count-bubble--lg">0</span></div>
      <div class="prose">
        <p class="h4">${esc(T.zeroTitle(d.q))}</p>
        <p>${esc(T.zeroHint)}</p>
        <ul class="cdx-pills cdx-pills--center" role="list">${sugg.map((s) => `<li><a class="cdx-pill" href="${esc(searchUrl(s))}">${esc(s)}</a></li>`).join('')}</ul>
      </div>
    </div>`;
  }

  // ---------------------------------------------------------------- Interaktion
  activeFilterCount() {
    const ui = this.state.ui;
    return FACET_KEYS.reduce((n, k) => n + (ui[k]?.length || 0), 0) + (ui.price ? 1 : 0) + (ui.onSale ? 1 : 0) + (ui.available ? 1 : 0);
  }

  refresh() { this.state.pages = 1; this.load({ push: true }); }

  // ✕ am aktiven Filter-Button (wie auf der Collection)
  clearGroup(key) { delete this.state.ui[key]; this.refresh(); }

  // Auswahl aus einem Formular (Filterleiste oder Drawer) übernehmen
  readForm(form) {
    const ui = {};
    for (const k of FACET_KEYS) {
      const vals = [...form.querySelectorAll(`[data-facet-key="${k}"]:checked`)].map((i) => i.value);
      if (vals.length) ui[k] = vals;
    }
    if (form.querySelector('[data-flag="onSale"]:checked')) ui.onSale = true;
    if (form.querySelector('[data-flag="available"]:checked')) ui.available = true;
    const lo = form.querySelector('[name="filter.v.price.gte"]')?.value;
    const hi = form.querySelector('[name="filter.v.price.lte"]')?.value;
    const p = this.data?.facets?.price;
    const loChanged = lo && (!p || Number(lo) > p.min), hiChanged = hi && (!p || Number(hi) < p.max);
    if (loChanged || hiChanged) ui.price = `${loChanged ? lo : 0}-${hiChanged ? hi : ''}`;
    const sort = form.querySelector('[data-sort-radio]:checked')?.value;
    return { ui, sort };
  }

  onChange(e) {
    const t = e.target;
    const form = t.closest('form');
    if (!form || form.matches('[data-search-form]')) return;
    if (form.matches('[data-cdx-drawer]')) return; // Drawer: übernehmen beim Schliessen / "Anwenden"
    if (t.type === 'range') return;              // Schieber: Wert landet per Theme-Logik im Zahlenfeld
    const { ui } = this.readForm(form);
    this.state.ui = ui;
    this.refresh();
  }

  applyDrawer() {
    const form = this.drawer?.querySelector('[data-cdx-drawer]');
    if (!form) return;
    const { ui, sort } = this.readForm(form);
    const changed = JSON.stringify(ui) !== JSON.stringify(this.state.ui) || (sort && sort !== this.state.sort);
    if (!changed) return;
    this.state.ui = ui;
    if (sort) this.state.sort = sort;
    this.refresh();
  }

  onClick(e) {
    const t = e.target;
    const card = t.closest('product-card[data-pid]');
    if (card && t.closest('a')) { track({ type: 'click', q: this.data?.q, productId: card.dataset.pid, position: Number(card.dataset.pos), source: 'page' }); recent.add(this.data?.q || ''); return; }
    if (t.closest('[data-more]')) { this.load({ append: true }); return; }
    if (t.closest('[data-reset]')) { e.preventDefault(); this.state.ui = {}; this.refresh(); return; }
    const ig = t.closest('[data-ignore]');
    if (ig) { this.state.ignore = [...new Set([...this.state.ignore, ig.dataset.ignore])]; this.refresh(); return; }
    const form = t.closest('[data-search-form]');
    if (form && t.closest('button[type="submit"]')) { e.preventDefault(); this.submitSearch(form); }
  }

  submitSearch(form) {
    const q = form.querySelector('input').value.trim();
    if (!q) return;
    recent.add(q);
    this.state = { q, sort: 'relevance', pages: 1, ui: {}, ignore: [] };
    this.load({ push: true });
  }
}

// Theme-Drawer schickt beim Schliessen "submit" an #facet-form → Auswahl übernehmen
document.addEventListener('submit', (e) => {
  const drawerForm = e.target.closest?.('[data-cdx-drawer]');
  if (drawerForm) { e.preventDefault(); drawerForm.closest('facet-drawer')?.cdxOwner?.applyDrawer(); }
}, true);

// Produktkarte im Markup der Theme-Karten (gleiche Klassen → gleiche Optik)
function cardHtml(p, i) {
  const onSale = p.compareAt && p.compareAt > p.price;
  const sizes = '(max-width: 699px) calc(50vw - 24px), (max-width: 1199px) calc(33vw - 40px), 300px';
  const ratio = 'aspect-square';
  const badges = [];
  if (!p.available) badges.push(`<span class="badge badge--sold-out">${T.soldOut}</span>`);
  else if (onSale) badges.push(`<span class="badge badge--on-sale">-${p.discount}%</span>`);
  else if (p.isNew) badges.push(`<span class="badge badge--primary-new">${T.new}</span>`);
  const swatches = p.swatches?.length > 1 ? `<ul class="cdx-card__swatches" role="list">${p.swatches.slice(0, 6).map((s, j) => `<li><a href="${esc(s.url)}" class="cdx-card__swatch${j === 0 ? ' is-current' : ''}${s.available ? '' : ' is-sold-out'}" title="${esc(s.label)}" data-swatch-img="${esc(img(s.image, 600))}" style="${swatchStyle(s.color)}" data-pid="${s.id}" data-pos="${i + 1}"></a></li>`).join('')}${p.swatches.length > 6 ? `<li class="cdx-card__swatch-more">+${p.swatches.length - 6}</li>` : ''}</ul>` : '';
  return `<product-card handle="${esc(p.handle)}" class="product-card product-card--blends cdx-card--fallback ${p.image2 ? 'product-card--show-secondary-media' : ''} bg-custom text-custom cdx-card" role="listitem" style="--background: 255 255 255; --text-color: 21 50 53;">
    <div class="product-card__badge-list">${badges.join('')}</div>
    <div class="product-card__figure">
      <a href="${esc(p.url)}" data-pid="${p.id}" data-pos="${i + 1}">
        <img src="${esc(img(p.image, 600))}" srcset="${srcset(p.image, [300, 400, 600, 800])}" sizes="${sizes}" alt="${esc(p.title)}" width="600" height="600" loading="${i < 4 ? 'eager' : 'lazy'}" class="product-card__image product-card__image--primary ${ratio}">
        ${p.image2 ? `<img src="${esc(img(p.image2, 600))}" srcset="${srcset(p.image2, [300, 400, 600, 800])}" sizes="${sizes}" alt="" width="600" height="600" loading="lazy" class="product-card__image product-card__image--secondary object-fill">` : ''}
      </a>
    </div>
    <div class="product-card__info">
      ${p.vendor ? `<span class="text-xs link-faded">${esc(p.vendor)}</span>` : ''}
      <div class="v-stack gap-0.5 w-full">
        <span class="product-card__title"><a href="${esc(p.url)}" class="bold" data-pid="${p.id}" data-pos="${i + 1}">${esc(p.title)}</a></span>
        <price-list class="price-list">
          <sale-price class="${onSale ? 'text-on-sale' : 'text-subdued'}"><span class="sr-only">Preis</span>${p.priceMax > p.price ? `${LANG === 'de' ? 'ab' : LANG === 'fr' ? 'dès' : 'from'} ` : ''}${money(p.price)}</sale-price>
          ${onSale ? `<compare-at-price class="text-subdued line-through">${money(p.compareAt)}</compare-at-price>` : ''}
        </price-list>
      </div>
      ${swatches}
    </div>
  </product-card>`;
}

// ==================================================================== Discovery: "Das könnte auch passen" (PDP)
class CdxSimilarProducts extends HTMLElement {
  async connectedCallback() {
    const handle = this.getAttribute('handle');
    if (!handle) return;
    try {
      const { hits } = await api('/api/similar', { handle, limit: Number(this.getAttribute('limit')) || 8 });
      if (!hits?.length) return;
      this.innerHTML = `<div class="container cdx-similar__inner">
        <h2 class="h3 cdx-similar__title">${esc(this.dataset.title || '')}</h2>
        <div class="cdx-similar__track" role="list">${hits.map((h, i) => cardHtml(h, i)).join('')}</div></div>`;
      this.classList.add('is-ready');
      this.addEventListener('click', (e) => { const a = e.target.closest('a[data-pid]'); if (a) track({ type: 'click', q: `similar:${handle}`, productId: a.dataset.pid, position: Number(a.dataset.pos), source: 'similar' }); });
    } catch { /* still bleiben – Seite funktioniert ohne */ }
  }
}

function priceLabel(v) {
  const [a, b] = String(v).split('-');
  if (a && b) return `CHF ${a}–${b}`;
  if (b) return `${T.to} CHF ${b}`;
  return `${T.from} CHF ${a}`;
}

// In den Warenkorb gelegt in einer Sitzung mit Suche (Kennzahl „Warenkorb nach Suche“ wie bei Shopify)
// Zusätzlich die Warenkorb-Attribute erneut setzen: Gab es beim Suchen noch keinen Warenkorb, kann ein gleichzeitig
// von einer anderen App angelegter Warenkorb unsere Attribute „verloren“ haben – jetzt existiert er sicher.
document.addEventListener('variant:add', (e) => {
  const terms = CFG ? sessionTerms() : [];
  if (!terms.length) return;
  setCartAttributes(terms);
  for (const item of e.detail?.items || []) if (item.product_id) track({ type: 'cart', productId: item.product_id });
});

// Hover über Farbpunkt → Kartenbild wechseln
document.addEventListener('pointerover', (e) => {
  const s = e.target.closest?.('.cdx-card__swatch[data-swatch-img]');
  if (!s) return;
  const imgEl = s.closest('.cdx-card')?.querySelector('.product-card__image--primary');
  if (imgEl && s.dataset.swatchImg) { imgEl.removeAttribute('srcset'); imgEl.src = s.dataset.swatchImg; }
});
// Enter im Suchfeld der Ergebnisseite
document.addEventListener('submit', (e) => {
  const form = e.target.closest?.('cdx-search-results [data-search-form]');
  if (!form) return;
  e.preventDefault();
  form.closest('cdx-search-results').submitSearch(form);
});

if (CFG) {
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', CdxInstantSearch);
  if (!customElements.get('cdx-search-results')) customElements.define('cdx-search-results', CdxSearchResults);
  if (!customElements.get('cdx-similar-products')) customElements.define('cdx-similar-products', CdxSimilarProducts);
}
